module.exports = __webpack_public_path__ + "img/logo.dfb08def.svg";